import React from 'react'

import SiteSelector from './component'

const SiteSelectorContainer = () => {
  return <SiteSelector />
}
export default SiteSelectorContainer
